class LoadMoreProducts extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more-button]');
    this.sentinel = this.querySelector('[data-load-more-sentinel]');
    this.spinner = this.querySelector('.loading__spinner');
    this.loading = false;

    if (this.button) {
      this.onButtonClick = this.onButtonClick.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
    }

    if ('IntersectionObserver' in window && this.sentinel) {
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '600px 0px 0px 0px',
      });
      this.observer.observe(this.sentinel);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.loading) this.loadMore();
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    this.loadMore();
  }

  loadMore() {
    const url = this.dataset.nextUrl;
    if (!url || this.loading) return;

    this.loading = true;
    this.setBusy(true);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Load more request failed: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.appendProducts(parsedHTML);
        this.swapControl(parsedHTML);
      })
      .catch((error) => {
        console.error(error);
        this.setBusy(false);
        this.loading = false;
      });
  }

  appendProducts(parsedHTML) {
    const currentGrid = document.getElementById('product-grid');
    const newGrid = parsedHTML.getElementById('product-grid');
    if (!currentGrid || !newGrid) return;

    const fragment = document.createDocumentFragment();
    Array.from(newGrid.children).forEach((item) => fragment.appendChild(item));
    currentGrid.appendChild(fragment);

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(currentGrid);
    }
  }

  swapControl(parsedHTML) {
    const newControl = parsedHTML.querySelector('load-more-products');

    // Replacing `this` with the freshly-fetched control gives us the correct
    // next-url (or removes the control entirely once there's no next page).
    // Because it's a custom element, connectedCallback fires again on insert.
    if (newControl) {
      this.replaceWith(newControl);
    } else {
      this.remove();
    }
  }

  setBusy(isBusy) {
    if (this.button) {
      this.button.toggleAttribute('aria-busy', isBusy);
      this.button.disabled = isBusy;
    }
    if (this.spinner) {
      this.spinner.classList.toggle('hidden', !isBusy);
    }
  }
}

if (!customElements.get('load-more-products')) {
  customElements.define('load-more-products', LoadMoreProducts);
}